import { ITxtProps, Txt } from '@vst/beam';

import styles from './styles.module.scss';

type MonthlyProductChargeProps = {
  id: string;
  productName: string;
  formattedPrice: string;
  priceColor?: ITxtProps['color'];
};

const MonthlyProductCharge = ({
  id,
  productName,
  formattedPrice,
  priceColor = 'subtle',
}: MonthlyProductChargeProps) => {
  return (
    <div data-cy={id} className={styles['pricing']}>
      <Txt variant="bodySmallRegular">{productName}</Txt>
      <Txt variant="bodySmallBold" color={priceColor}>
        {formattedPrice}
      </Txt>
    </div>
  );
};

export default MonthlyProductCharge;
